import { useLocation } from "wouter";
import { useSubscription } from "../../context/SubscriptionContext";
import SubscriptionLockout from "./SubscriptionLockout";

export default function LockoutGuard({ children }) {
  const [location] = useLocation();
  const subscription = useSubscription();

  const isBillingRoute = [
    "/subscription",
    "/settings/subscription",
    "/payment-billing",
    "/settings/payment-billing",
    "/payment-methods",
    "/settings/payment-methods",
    "/payment-success",
    "/payment-failed"
  ].some(route => location.startsWith(route));

  // Determine lockout condition
  const isLockedOut = (subscription.isTrial && subscription.trialDaysLeft <= 0) ||
                      (!subscription.isTrial && subscription.subscriptionDaysLeft <= 0);

  if (isLockedOut && !isBillingRoute) {
    return (
      <>
        {children}
        <SubscriptionLockout isTrial={subscription.isTrial} />
      </>
    );
  }

  return children;
}
